import React from 'react';
import { useAuthContext } from './AuthProvider';
import NoPermission from '../NoPermission';
const PermissionGuard = ({ children, permissions }) => {
  const { user } = useAuthContext();

  if (!user) {
    return <div>You are not authorized to access this page</div>;
  }

  if (
    !user.permissions.some((permission) => permissions.includes(permission))
  ) {
    return <NoPermission />;
  }

  return children;
};

export default PermissionGuard;
